import env from './env'

/*
 * API_1 配置
 */
const API_1_CONF = {
  dev: 'http://192.168.2.198:8082', // devhttp://192.168.0.196:8082
  development: 'http://192.168.0.196:8082', // dev
  //192.168.0.51:8082//192.168.0.196:8082
  test: '', // 测试环境
  production: 'http://182.61.21.235', // 线上环境
}

export const API_1 = API_1_CONF[env]

export const Global = {
  topInfo: '/fy/bid/lista', //5条招标热门榜单
  topHot: '/fy/othercpcz/hotsou', //首页搜索框下热词
  hotInfo: '/fy/adv/advlist', //热门资讯
  swiper: '/fy/othercpcz/otherone', //轮播图
  country: '/fy/bid/butpncoun', //国家页列表
  screenCountry: '/fy/bid/nationalcountrylist',//国家地区筛选
  homeCountry: '/fy/bid/counind', //首页国家列表 //othercpce/counind
  hotTag: '/fy/othercpcz/buttonoth', //首页资讯筛选标签
  find: '/fy/bid/screenbid', //搜索结果页筛选
  detail: '/fy/bid/noticetext', //详情页
  detailOther: '/fy/bid/noticetextlable',//详情页右侧相关和下侧更多信息
  search: '/fy/bid/searcword', //搜索框
  top: '/fy/othercpce/screentop', //行业
  end: '/fy/othercpce/screenend', //信息
  email: '/fy/user/regisus', //发送验证码
  emailCode: '/fy/user/regisust', //验证邮箱验证码
  phone: '/fy/user/loginphone', //手机验证码
  phoneCode: '/fy/user/loginphonet', //验证手机验证码
  getHot: '/fy/bid/lable', //热门资讯tag搜索
  like: '/fy/othercpce/likezixun', //详情页右侧推荐
  paichu: '/fy/bid/ctcontrast', //区域筛选国家 删除国家标签中英文对照用
  upload: '/fy/user/inputhead', //上传头像
  userInfo: '/fy/user/finduser', //个人中心-获取信息
  edituser2: '/fy/user/modifyuser', //个人中心-修改信息
  imgUrl: '/images/headportrait/', //用户头像图片路径，后面加上返回的图片名字
  sc: '/fy/user/ucollection', //收藏与取消收藏
  findsc: '/fy/user/useecollection', //收藏页列表
  addSub: '/fy/user/ussCollection', //新增订阅
  subList: '/fy/user/usseeCollection', //订阅列表
  delSub: '/fy/user/userussModifyCollection', //删除订阅
  send: '/fy/user/userbidexport', //提交导出
  price: '/fy/bid/fieldpacket', //价格表
  browse: '/fy/user/userexcelpreview', //预览购买数据接口userid 和excelcode
  count: '/fy/user/userexcelprice', //计算总金额
  excel: '/fy/user/exceldownload', //支付成功返回
  mydata: '/fy/user/exportrecords', //我的数据
  pass: '/fy/user/loginuserph', //密码登录
  repeat: '/fy/user/repeatuseremailphone', //修改查重
  modifyAccount: '/fy/user/updatephone',//
  infoDetail: '/fy/adv/Details', //相关舆情详情页
  public: '/fy/bid/bidcms',//公共页接口
  zixunhot: '/fy/othercpcz/zixunhot',//首页热门资讯筛选标签
  advhost: '/fy/adv/advhost',//首页热门资讯筛选结果
  language: '/fy/yiyu/meta-data',//翻译下单页语项选择
  priceSetting: '/fy/yiyu/price-setting',//翻译下单页语项选择
  uploadhandler: '/fy/yiyu/file-uploadhandler',//翻译下单页上传文件
  creatOrder: '/fy/yiyu/creat-order',//创建翻译订单
  text: '/fy/yiyu/generate-text',//上传翻译内容（非文件）
  myOrder: '/fy/yiyu/my-order',//我的订单列表
  eval: '/fy/yiyu/evaluation',//评价提交
  orderDetail: '/fy/yiyu/order-details',//订单详情
  orderPay: '/fy/yiyu/pay-order',//支付订单
  findInfo: '/fy/adv/filteradv',//资讯筛选页
  VIPprice: '/fy/user/pricelist',//会员价格
  vippay: '/fy/user/recharge/subscription'//会员支付
}
